import React from 'react';
import Highcharts, { SeriesOptionsType } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import COLORS from '../../core/constants/colors';
import { OneLineChartModel } from '../../core/models/power';

import './OneLineChart.scss';

interface IOneLineChart {
  title: string;
  yAxisTitle: string;
  data: OneLineChartModel;
}

const OneLineChart = React.memo(function OneLineChart({
  title,
  data,
  yAxisTitle,
}: IOneLineChart): JSX.Element {
  if (data.series.some((s) => !s.chart || s.chart.length === 0)) {
    return <span className="OneLineChart warning">Something went wrong</span>;
  }

  const chartData = data.series.map(
    (series) =>
      ({
        type: 'spline',
        name: series.marketName,
        data: series.chart.map((seriesData) => [String(seriesData.x), seriesData.y]),
      } as SeriesOptionsType)
  );

  const categories = data.series[0].chart.map((seriesData) => String(seriesData.x));

  const options: Highcharts.Options = {
    chart: {
      type: 'spline',
      zoomType: 'x',
      backgroundColor: COLORS.backgroundSecond,
      animation: false,
    },

    credits: {
      enabled: false,
    },
    colors: [COLORS.red, COLORS.blue],
    title: {
      text: undefined,
    },

    yAxis: {
      lineWidth: 0,

      title: {
        text: yAxisTitle,
        x: 0,
      },
    },

    xAxis: {
      categories: [...categories],
      tickWidth: 0,
      tickInterval: 1,

      title: {
        text: 'Settlement Period',
        margin: 15,
        style: {
          fontWeight: '600',
          fontSize: '13px',
          lineHeight: '18px',
          color: COLORS.content,
        },
      },
      labels: {
        align: 'left',
        rotation: -90,
      },
    },

    legend: {
      enabled: true,
    },

    plotOptions: {
      spline: {
        marker: {
          enabled: false,
        },
      },

      series: {
        label: {
          connectorAllowed: false,
        },
        animation: false,
      },
    },

    series: [...chartData],
  };

  return (
    <div className="OneLineChart">
      <div className="OneLineChart__title fsbc pl-3">
        <h3>{title}</h3>
        <h4>{data.date}</h4>
      </div>

      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
});

export default OneLineChart;
